import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import { UnlinkUserDevice} from "../../../reduxToolkit/Providers/providersApi";
import {toast} from "react-toastify";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const UnlinkDeviceChangeApp = (props) => {
    const { userId, onHide, onConfirm } = props;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { getProviderEmployeeDetail } = useSelector((state) => state?.providersSlice);

    const handleUnlinkDevice = () => {
        dispatch(UnlinkUserDevice(userId || getProviderEmployeeDetail?.user?.id)).then(({payload: {data: { success }}}) => {
            if(success){
                toast.success(t("has_been_unlinked_successfully"));
                onHide();
                onConfirm();
            }
            else toast.success(t("something_went_wrong_2"));
        });
    }
    return {
        t,
        handleUnlinkDevice
    };
};

export default UnlinkDeviceChangeApp;
